import { createContext, useContext } from "react";

import type { LayersList } from "@deck.gl/core";
import type { GoogleMapsOverlay } from "@deck.gl/google-maps";

import type { DeckOverlayType, DeckSlot } from "./DeckSlot";

export interface IDeckOverlaysContext {
  overlays: Record<DeckOverlayType, GoogleMapsOverlay>;
  removeLayers: (slot: DeckSlot, key: symbol) => void;
  setLayers: (slot: DeckSlot, key: symbol, layers: LayersList) => void;
}

export const DeckOverlaysContext = createContext<IDeckOverlaysContext | null>(null);

export const useDeckOverlays = (): IDeckOverlaysContext => {
  const context = useContext(DeckOverlaysContext);
  if (!context) {
    throw new Error("useDeckOverlays must be used inside DeckOverlaysProvider");
  }
  return context;
};
